import { render, staticRenderFns } from "./UserDetailsDlg.vue?vue&type=template&id=f6d3e95c&scoped=true&"
import script from "./UserDetailsDlg.vue?vue&type=script&lang=ts&"
export * from "./UserDetailsDlg.vue?vue&type=script&lang=ts&"
import style0 from "./UserDetailsDlg.vue?vue&type=style&index=0&id=f6d3e95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d3e95c",
  null
  
)

export default component.exports